// removed by extract-text-webpack-plugin
module.exports = {"shopAtContainer":"shopAtContainer__gYg23","shopAtHeading":"shopAtHeading__1beSZ","merchantsContainer":"merchantsContainer__1IAqK","onlineStoresText":"onlineStoresText__2BdkW","lenderMerchantListDiv":"lenderMerchantListDiv__PuxWo"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/merchants/style.css
// module id = +v6m
// module chunks = 459